(() => {
  if (customElements.get('sss-battery-specs')) return;
  const format = new Intl.NumberFormat('en-CA', {maximumFractionDigits: 2});
  customElements.define('sss-battery-specs', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const button = this.querySelector('.sss-battery-units');
      if (!button) return;
      this.ready = true;
      this.metric = false;
      const cells = [...this.querySelectorAll('td')].filter(cell =>
        !/SKU|Manufacturer|chemistry|Terminal/i.test(cell.previousElementSibling?.textContent || '')
      ).map(cell => ({cell, text: cell.textContent.trim()}));
      const convertible = cells.some(({text}) => /(?:\bin|\blb|°C)\b/.test(text));
      button.hidden = !convertible;
      const update = () => {
        for (const {cell, text} of cells) {
          // Only numeric quantities with known units; model identifiers remain untouched.
          if (!/^[-\d.\s×:LWHA-Za-z°]+$/.test(text) || !/\d/.test(text)) continue;
          let unit = /\bin\b/.test(text) ? 'in' : /\blb\b/.test(text) ? 'lb' : /°C/.test(text) ? 'c' : '';
          const value = text.replace(/-?\d+(?:\.\d+)?/g, raw => {
            let n = Number(raw);
            if (this.metric && unit === 'in') n *= 25.4;
            if (this.metric && unit === 'lb') n *= 0.45359237;
            if (!this.metric && unit === 'c') n = n * 9 / 5 + 32;
            return format.format(n);
          });
          cell.textContent = this.metric ? value.replace(/\bin\b/g, 'mm').replace(/\blb\b/g, 'kg') : value.replace(/°C/g, '°F');
        }
        button.textContent = this.metric ? 'Show imperial units' : 'Show metric units';
        button.setAttribute('aria-pressed', String(this.metric));
      };
      button.addEventListener('click', () => { this.metric = !this.metric; update(); });
      update();
    }
  });
})();
